/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import CalendarSquareRegularEvent from './calendar-square-regular-event-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <CalendarSquareRegularEvent {...validProps} />;
}

SvgComponent.iconName = 'calendarSquareRegularEvent';

export const CalendarSquareRegularEventIcon = svgIconWrapper(SvgComponent);
